import { render, staticRenderFns } from "./ChipInputGroup.vue?vue&type=template&id=0221da18&scoped=true"
import script from "./ChipInputGroup.vue?vue&type=script&lang=js"
export * from "./ChipInputGroup.vue?vue&type=script&lang=js"
import style0 from "./chip-input-group.scss?vue&type=style&index=0&id=0221da18&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0221da18",
  null
  
)

export default component.exports